module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewRelievingletter"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printRelievingletter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printRelievingletter"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "100",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _c('strong', [_vm._v("Relieving Letter")])])]), _vm._v(" "), (_vm.seeRecord.user) ? _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "30%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.user.code,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                          Show this if the rendering fails.\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.seeRecord.user) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('td', [_c('b', [_vm._v("\n                          " + _vm._s(_vm.seeRecord.user.name) + " "), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.address) + ",")]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.city) + ",")]), (_vm.seeRecord.state) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.state.name) + " -")]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.pin))]), _c('br')])]), _vm._v(" "), (_vm.seeRecord.branch) ? _c('td', {
    staticClass: "text-right"
  }, [_vm._v("Branch: " + _vm._s(_vm.seeRecord.branch.name) + " "), _c('br'), _vm._v("Date: " + _vm._s(_vm._f("myDate")(_vm.currDate)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center text-bold"
  }, [_vm._v("Relieving Letter")]), _vm._v(" "), _c('p', [_vm._v("Dear "), (_vm.seeRecord.user) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.user.name))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("We are in receipt of your resignation dated " + _vm._s(_vm._f("myDate")(_vm.resignationDate)) + ".")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("We have accepted your resignation and as per company policy you will be relieved with effect from " + _vm._s(_vm._f("myDate")(_vm.lastDateOfEmployment)))]), _vm._v(" "), _c('p', [_vm._v("We wish you all the best for your future endeavors.")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Thanking you")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', [_vm._v("For")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.seeRecord.user) ? _c('p', [_vm._v(" " + _vm._s(_vm.seeRecord.user.name))]) : _vm._e(), _vm._v(" "), _c('p', [(_vm.seeRecord.designation) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.designation.name))]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()])])])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2df7ace8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/RelievingLetter.vue
// module id = 815
// module chunks = 0